export default __webpack_public_path__ + "static/media/YoutubeLogo.c21fb01d.svg";